const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    intractName: "Trackmydoc",
    intractEmail: "trackmydoc@gmail.com",
    firmType: "cpa",
  },
  "client-mahima.trackmydoc.com": {
    name: "Mahima Jain",
    domainName: "mahima.com",
    logo: "/assets/logo/logo.png",
    favicon: "/assets/logo/favicon.ico",
    intractName: "Mahima Jain",
    intractEmail: "mahima.info@aol.com",
    firmType: "corporate",
  },
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
